import React from 'react';
import PropTypes from 'prop-types';
import { prop } from 'ramda';
import moment from 'moment';

import FormSection from 'containers/FormSectionContainer';
import FieldSet from 'containers/FieldSetContainer';
import FormField from 'containers/FormField';
import ConditionalSection from 'containers/ConditionalSection';
import { withSession } from 'containers/SessionProvider';

import RadioButtonGroup from 'components/RadioButtonGroup';
import CheckboxGroup from 'components/CheckboxGroup';
import TextFieldArea from 'components/TextFieldArea';
import Datepicker from 'components/Datepicker';

import FormProvider from 'routes/Documents/containers/FormProvider';

import { has } from 'lib/conditions';
import { getGender } from 'lib/ssn';

// True if female user
const getGenderFemale = session => prop('citizedId', session) && getGender(prop('citizedId', session)) === 'female';

const contactType = [
  { value: 'appointmentDoctor', label: 'next.opts.appointmentDoctor' },
  { value: 'appointmentNurse', label: 'next.opts.appointmentNurse' },
  { value: 'callDoctor', label: 'next.opts.callDoctor' },
  { value: 'callNurse', label: 'next.opts.callNurse' },
  { value: 'acuteCallNurse', label: 'next.opts.acuteCallNurse' },
  { value: 'acuteVisitNurse', label: 'next.opts.acuteVisitNurse' },
];

const contactSubject = session => {
  let subArr = [
    { value: 'msSymptoms' },
    { value: 'medication' },
    { value: 'medicationBenefitRenewal' },
    { value: 'rehabilitation' },
    { value: 'workingAbility' },
    { value: 'cForm' },
  ];
  // Add question about pregnancy if female
  if (getGenderFemale(session)) subArr.push({ value: 'pregnancyOrBirthcontrol' });
  subArr.push({ value: 'other' });
  return subArr;
};

const subjectOpt = opt => `next.opts.${opt}`;

const contactMaxDate = moment().add(3, 'years').toDate();

const NextForm = ({ session, ...props }) => (
  <FormProvider {...props}>
    <FormSection localeId="next.sections.contactDate">
      <FieldSet localeId="next.labels.contactDate">
        <FormField name="contactDate" component={Datepicker} maxDate={contactMaxDate} />
      </FieldSet>
    </FormSection>
    <FormSection localeId="next.sections.contact">
      <FieldSet localeId="next.labels.contactType">
        <FormField name="contactType" component={RadioButtonGroup} options={contactType} />
      </FieldSet>
      <FieldSet localeId="next.labels.contactSubject">
        <FormField
          name="contactSubject"
          component={CheckboxGroup}
          optionFormatter={subjectOpt}
          options={contactSubject(session)}
        />
      </FieldSet>
      <ConditionalSection condition={has('contactSubject', 'other')}>
        <FieldSet localeId="next.labels.other">
          <FormField
            name="otherDetail"
            component={TextFieldArea}
            hintLocale="next.other"
            rows={4}
            viewStyle={{ width: '100%', maxWidth: '35rem' }}
          />
        </FieldSet>
      </ConditionalSection>
    </FormSection>
  </FormProvider>
);

NextForm.propTypes = {
  session: PropTypes.object,
};

export default withSession(NextForm);
